module.exports = __webpack_public_path__ + "img/GDT.e931fa57.png";